import React from "react";
import ProtectedContent from "../../components/ProtectedContent";
import SafeView from "../../components/safeView/SafeView";
import JobsTable from "./jobsTable";

const Jobs = () => {
  return (
    <SafeView>
      <ProtectedContent perms={["view_taskresult"]} showFallback>
        <div className="table-container">
          <JobsTable />
        </div>
      </ProtectedContent>
    </SafeView>
  );
};

export default Jobs;
